import { Box, Text } from '@rbilabs/universal-components';

export const MenuEmptyStateContainer = Box.withConfig({
  alignItems: 'center',
  padding: '$8',
});
export const MenuEmptyStateTitle = Text.withConfig({
  variant: 'headerOne',
  textAlign: 'center',
});
export const MenuEmptyStateMessage = Text.withConfig({
  variant: 'copyOne',
  textAlign: 'center',
  maxWidth: '$64',
  padding: '$2',
});
export const MenuEmptyStateImageWrapper = Box.withConfig({
  flexDirection: 'row',
  height: '$40',
  marginTop: '$4',
  marginBottom: '$8',
});
